import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Table, Input, Tooltip, Space, Tag, Select } from "antd";
import { HighlightOutlined, SearchOutlined, BulbOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";

// STATUS
const options_status = {
  [-1]: <Tag color="orange">Em formação</Tag>,
  [0]: <Tag color="green">Aguard. Avaliação.</Tag>,
  [1]: <Tag color="orange">Ideia aceita (Aguard. Informações)</Tag>,
  [2]: <Tag>Ideia c/ oportunidade</Tag>,
  [3]: <Tag color="green">Retorno de info.</Tag>,
  [4]: <Tag color="green">Em desenvolvimento</Tag>,
  [5]: <Tag>Finalizado</Tag>,
};

// STATUS
const options_status_filter = [
  { value: 999, label: "Todos" },
  { value: 0, label: "Aguard. Avaliação" },
  { value: 1, label: "Ideia aceita (Aguard. Informações)" },
  { value: 2, label: "Ideia c/ oportunidade" },
  { value: 3, label: "Retorno de info." },
  { value: 4, label: "Em desenvolvimento" },
  { value: 5, label: "Finalizado" },
];

export const SugestoesRecebidas = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [search, setSearch] = useState("");
  const [filtroStatus, setFiltroStatus] = useState(999);

  useEffect(() => {
    listarSugestoes();
  }, []);

  // LISTAR
  const listarSugestoes = async () => {
    setLoading(true);
    const api = await http("get", `v1/sugestoes/listar_recebidas`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS
  const columns = [
    {
      title: "Nº",
      dataIndex: "id",
      sorter: (a, b) => a.id?.toString()?.localeCompare(b.id?.toString()),
    },
    {
      title: "Colaborador",
      dataIndex: "colaborador",
      sorter: (a, b) => a.colaborador?.localeCompare(b.colaborador),
    },
    {
      title: "Título",
      dataIndex: "titulo",
      sorter: (a, b) => a.titulo?.localeCompare(b.titulo),
    },
    {
      title: "Área",
      dataIndex: "area",
      sorter: (a, b) => a.area?.localeCompare(b.area),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => options_status[e.status],
      sorter: (a, b) => a.status?.toString()?.localeCompare(b.status?.toString()),
    },
    {
      title: "Ações",
      width: 80,
      render: (_, e) => (
        <Space.Compact>
          <React.Fragment>
            <Tooltip title="Avaliar sugestão">
              <Button
                loading={loading}
                onClick={() => navigate(`/sugestoes/avaliacao/${e.id}`)}
                icon={<HighlightOutlined />}
              />
            </Tooltip>
          </React.Fragment>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, status) => {
    let filteredData = dados?.filter(
      (val) =>
        val.titulo?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.colaborador?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.area?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    if (status !== 999) {
      filteredData = filteredData?.filter((e) => e.status === status);
    }

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, filtroStatus) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Inova" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Sugestões"
              subtitle="Gerenciar sugestões recebidas"
              icon={<BulbOutlined />}
              loading={loading}
            />
            <Divider />

            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />

                <Select
                  style={{ minWidth: 180 }}
                  value={filtroStatus}
                  onChange={(e) => setFiltroStatus(e)}
                  options={options_status_filter}
                />
              </Space>

              <Divider />
              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
